export default "__VITE_ASSET__BqtQzNlc__"